// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"766b3c94","927":"1c42ba22"}[chunkId] + ".chunk.js";
};